const BackIcon = () => {
  return (
    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 3.94727H1" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3.94737 6.89474L1 3.94737L3.94737 1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default BackIcon